import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import {ColumnsEdit} from "../../../../../../../../../types/models/column-table-edit";
const {INPUT, SELECT, DATE, COLOR, COMBO_BOX} = FIELD_TYPE;
const css = {xs: 24, sm: 24, md: 24, lg: 8, xl: 8};
const dataFields: ColumnsEdit = [
  {
    type: INPUT,
    label: "Mã địa chỉ",
    name: "maDiaChi",
    // rules: [{required: true, message: "Chưa nhập mã loại hợp đồng"}],
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 14, lg: 18, xl: 18},
    labelCol: {xs: 24, sm: 10, md: 10, lg: 6, xl: 6},
  },
  {
    type: COMBO_BOX,
    label: "Địa chỉ làm việc",
    name: "diaChiLamViec",
    options: [
      { value: "Biệt thự Mimosa 10-11-12, khu Thảo Nguyên - Khu đô thị Ecopark - Huyện Văn Giang - Tỉnh Hưng Yên", label: "Biệt thự Mimosa 10-11-12, khu Thảo Nguyên - Khu đô thị Ecopark - Huyện Văn Giang - Tỉnh Hưng Yên" },
      //{ value: "Hà Nội", label: "Hà Nội" },
      {value:"Số 458 Đường Minh Khai, Phường Vĩnh Tuy, Quận Hai Bà Trưng, Thành phố Hà Nội, Việt Nam",label:"Số 458 Đường Minh Khai, Phường Vĩnh Tuy, Quận Hai Bà Trưng, Thành phố Hà Nội, Việt Nam"}
    ],
    //rules: [{required: true, message: "Chưa nhập tên loại hợp đồng"}],
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 14, lg: 18, xl: 18},
    labelCol: {xs: 24, sm: 10, md: 10, lg: 6, xl: 6},
  },
  {
    type: COMBO_BOX,
    label: "Địa chỉ làm việc tiếng anh",
    name: "diaChiLamViecTA",
    options: [
      { value: "Shophouse Mimosa 10-11-12, Thao Nguyen, Ecopark, Van Giang District, Hung Yen Province, Viet Nam", label: "Shophouse Mimosa 10-11-12, Thao Nguyen, Ecopark, Van Giang District, Hung Yen Province, Viet Nam" },
      //{ value: "Hà Nội", label: "Hà Nội" },
      {value:"458 Minh Khai Street, Vinh Tuy Ward, Hai Ba Trung District, Hanoi City, Vietnam",label:"458 Minh Khai Street, Vinh Tuy Ward, Hai Ba Trung District, Hanoi City, Vietnam"}
    ],
    //rules: [{required: true, message: "Chưa nhập tên loại hợp đồng"}],
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 14, lg: 18, xl: 18},
    labelCol: {xs: 24, sm: 10, md: 10, lg: 6, xl: 6},
  },
  // {
  //   type: COMBO_BOX,
  //   label: "Mã cấu hình nghỉ phép",
  //   name: "idNgayNghiPhep",
  //   rules: [{required: true, message: "Chưa nhập mã nghỉ phép"}],
  //   css:css,
  //   wrapperCol: { xs: 24,sm:14, md: 14, lg: 14, xl: 14 },
  //   labelCol: { xs: 24,sm:10, md: 10, lg: 10, xl: 10},
  // },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
    css: css,
    wrapperCol: {xs: 24, sm: 14, md: 14, lg: 18, xl: 18},
    labelCol: {xs: 24, sm: 10, md: 10, lg: 6, xl: 6},
  },
];
export {dataFields};
